module.exports = __webpack_public_path__ + "media/images/landing-pages/lp-pri-crs-2-b988a7cfd2a5af242af12c79c82a0c45.png";